import DefinitionList from './DefinitionList.vue';
import DefinitionListTerm from './DefinitionListTerm.vue';
import DefinitionListDescription from './DefinitionListDescription.vue';

export {DefinitionListTerm, DefinitionListDescription};
export default DefinitionList;
